// extracted by mini-css-extract-plugin
export default {"root":"AspectRatioWrapper_root__8ihQp","aspectPadding":"AspectRatioWrapper_aspectPadding__6PSJw","aspectBox":"AspectRatioWrapper_aspectBox__8deA4"};